import { render, staticRenderFns } from "./ManageSpecial.vue?vue&type=template&id=8213cd32&"
import script from "./ManageSpecial.vue?vue&type=script&lang=js&"
export * from "./ManageSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports